import API from '../../../api/axios';

const locationService = {
    async getCountries() {
        return API.get('/location/countries');
    },

    async getCities(countryId) {
        return API.get(`/location/countries/${countryId}/cities`);
    },

    async getLocations(cityId) {
        return API.get(`/location/cities/${cityId}/locations`);
    },
};

export default locationService;